import { Tenant } from "./Tenant";
import { User } from "./User";
import { Item } from "./item";
import { Label } from "./Label";

export class Note implements Item {
  public "@id"?: string;

  constructor(
    _id?: string,
    public note?: string,
    public title?: string,
    public pinned?: boolean,
    public checkList?: Array<{ text: string; done?: boolean }>,
    public labels?: Label[] | string[],
    public terminalCall?: string,
    public tenant?: Tenant[]| string[],
    public user?: User[]| string[],
  ) {
    this["@id"] = _id;
  }
}
